import amplitude from "amplitude-js";

import { AMPLITUDE_API_KEY, ENABLE_AMPLITUDE, NODE_ENV } from "../../config/envConfig";

class AmplitudeService {
  #instance;
  #isEnabled;

  constructor(isEnabled, amplitudeApiKey) {
    this.#isEnabled = isEnabled;
    this.#instance = amplitude.getInstance();
    this.#instance.init(amplitudeApiKey);

    this.logEvent = this.environmentBasedExecution("[Amplitude LogEvent]", this.#instance.logEvent);
    this.setUserId = this.environmentBasedExecution("[Amplitude setUserId]", this.#instance.setUserId);
    this.setUserProperties = this.environmentBasedExecution(
      "[Amplitude setUserProperties]",
      this.#instance.setUserProperties,
    );
  }

  environmentBasedExecution(logMessage, method) {
    return (...args) => {
      if (this.#isEnabled) {
        try {
          method.call(this.#instance, ...args);
        } catch (error) {
          console.error("Error executing Amplitude method:", error);
        }
      } else {
        console.log(logMessage, ...args);
      }
    };
  }

  updateUserData(userDetails) {
    this.setUserId(userDetails?._id);
    this.setUserProperties({
      name: userDetails?.name,
      email: userDetails?.email,
      otp_email: userDetails?.otp_email,
    });
  }
}

const amplitudeInstance = new AmplitudeService(
  ENABLE_AMPLITUDE === "true" && ["development", "staging", "uat", "production"].includes(NODE_ENV),
  AMPLITUDE_API_KEY,
);
export default amplitudeInstance;
